module.exports = __webpack_public_path__ + "static/media/adminBackgroundImage.4ef8252d.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Landing/adminBackgroundImage.png
// module id = 1124
// module chunks = 0